import "./Profile.css";

function Headersocials() {
  return (
    <div className="header">
      <div className="header-socials">
        <a href="#">
          <i className="fa fa-facebook"></i>
        </a>
        <a href="#">
          <i className="fa fa-twitter"></i>
        </a>
        <a href="#">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="#">
          <i className="fa fa-linkedin"></i>
        </a>
        <a href="#">
          <i className="fa fa-github"></i>
        </a>
      </div>
      <div className="scroll-down">
        <a href="#">Scroll Down</a>
      </div>
    </div>
  );
}

export default Headersocials;
